/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Price_Setup_IncompleteInputs */

const en_error_price_setup_incomplete = /** @type {(inputs: Error_Price_Setup_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tab is missing values needed to confirm it.`)
};

/**
* | output |
* | --- |
* | "The tab is missing values needed to confirm it." |
*
* @param {Error_Price_Setup_IncompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_price_setup_incomplete = /** @type {((inputs?: Error_Price_Setup_IncompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Price_Setup_IncompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_price_setup_incomplete(inputs)
});